import React from "react";
import EventsAtAptechSection from "../components/EventsAtAptech/EventsAtAptech.tsx";
import MetaComponent from "../components/CommonComponents/MetaComponent.tsx";
const EventsAtAptech = () => {
  return (
    <div>
      <MetaComponent
        title="Events at Aptech – a leading vocational training institute"
        desc="Aptech hosts different events round the year across its multiple brands. Events at Aptech help students interact with industry leaders."
        keywords="Aptech events, Events at Aptech, Aptech Brands, Latest events at Aptech"
      />
      <EventsAtAptechSection />
    </div>
  );
};

export default EventsAtAptech;
